'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Partition;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _group = require('@vx/group');

var _d3Hierarchy = require('d3-hierarchy');

var _HierarchyDefaultNode = require('../HierarchyDefaultNode');

var _HierarchyDefaultNode2 = _interopRequireDefault(_HierarchyDefaultNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

Partition.propTypes = {
  root: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.func
};

function Partition(_ref) {
  var top = _ref.top,
      left = _ref.left,
      className = _ref.className,
      root = _ref.root,
      size = _ref.size,
      round = _ref.round,
      padding = _ref.padding,
      children = _ref.children,
      _ref$nodeComponent = _ref.nodeComponent,
      nodeComponent = _ref$nodeComponent === undefined ? _HierarchyDefaultNode2.default : _ref$nodeComponent,
      restProps = _objectWithoutProperties(_ref, ['top', 'left', 'className', 'root', 'size', 'round', 'padding', 'children', 'nodeComponent']);

  var partition = (0, _d3Hierarchy.partition)();
  if (size) partition.size(size);
  if (round) partition.round(round);
  if (padding) partition.padding(padding);

  var data = partition(root);

  if (!!children) {
    return _react2.default.createElement(
      _group.Group,
      { top: top, left: left, className: (0, _classnames2.default)('vx-partition', className) },
      children({ data: data })
    );
  }

  return _react2.default.createElement(
    _group.Group,
    { top: top, left: left, className: (0, _classnames2.default)('vx-partition', className) },
    nodeComponent && data.descendants().map(function (node, i) {
      return _react2.default.createElement(
        _group.Group,
        { key: 'partition-node-' + i },
        _react2.default.createElement(nodeComponent, { node: node })
      );
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/hierarchy/build/hierarchies/Partition.js
// module id = 1499
// module chunks = 0